import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { MARKET_LIST } from "@/data/markets";
import { ArrowUpRight } from "lucide-react";

export function Markets() {
  return (
    <section id="markets" data-testid="markets-section" className="py-24 px-6 md:px-12 bg-surface border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
            <div>
              <p className="font-mono text-[11px] tracking-[0.35em] text-gold uppercase mb-6">Markets We Serve</p>
              <h2 className="font-serif font-light text-3xl md:text-5xl tracking-tight max-w-2xl">
                Senior advisory across the regions that matter most.
              </h2>
            </div>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {MARKET_LIST.map((m, i) => (
            <Reveal key={m.slug} delay={i * 0.06}>
              <Link to={`/markets/${m.slug}`} data-testid={`markets-card-${m.slug}`}
                className="group block border border-white/12 hover:border-gold/50 p-8 h-full transition-colors duration-300 bg-ink/40">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-serif text-2xl md:text-3xl font-light group-hover:text-gold transition-colors">{m.region}</h3>
                  <ArrowUpRight size={20} className="text-muted2 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
                <p className="text-muted2 text-sm leading-relaxed line-clamp-3">{m.intro}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
